import React, { useState, useEffect,useRef } from "react";
import NavigationBar from "../NavigationBar";
import ETLWorkflow from "../ETLWorkflow";
import NewFileTab from "./NewFileTab";
import { Box,  } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ExitConfirmationModal from "./ExitConfirmationModal";
import { useThemeContext } from "../../Context/ThemeContext"; 
import useLogout from '../../hooks/useLogout';
// import { toast } from "react-toastify";

const ParentComponent = () => {
  const { workflowName: workflowId } = useParams();
  console.log('ParentComponent workflowId:::', workflowId);
  const [selectedTab, setSelectedTab] = useState("Workflow");
  const [mainMenu, setMainMenu] = useState("Workflow");
  const [openExitModal, setOpenExitModal] = useState(false);
  const { darkMode, toggleDarkMode } = useThemeContext(); // Use the context instead of local state

  const navigate = useNavigate();
  // Create a ref for ETLWorkflow
  const etlWorkflowRef = useRef();


  useEffect(() => {
    console.log("Updated Tab:", selectedTab);
    console.log("Workflow Id:", workflowId);
  }, [selectedTab, workflowId]);

  const handleTabChange = (tab) => {
    console.log("Tab clicked:", tab);

    if (["File", "Edit", "Help"].includes(tab)) {
      setMainMenu(tab);
      setSelectedTab(tab);
    } else if (tab === "Dashboard") {
      setOpenExitModal(true);
    } else {
      if (["New File", "Open File", "Debug Console"].includes(tab)) {
        setMainMenu("File");
      } else if (["Rename", "Copy Workflow", "Paste Workflow"].includes(tab)) {
        setMainMenu("Edit");
      } else if (["Help Document", "Contact Support", "Feedback"].includes(tab)) {
        setMainMenu("Help");
      } else {
        setMainMenu(tab);
      }
      setSelectedTab(tab);
    }
  };

   const handleCloseExitModal = (action) => {
    setOpenExitModal(false);

    if (action === 'save') {
      if (etlWorkflowRef.current) {
        etlWorkflowRef.current.handleWorkflowSave(); // Access and call the method
        setTimeout(() => {
          navigate("/userdashboard");
        }, 1500);
        // navigate("/userdashboard");
        
      }
       
    } else if (action === 'no') {
        navigate("/userdashboard");
    } else if (action === 'cancel') {
        return;
    }
};

  const handleLogout = useLogout();

  const renderContent = () => {
    switch (selectedTab) {
      case "Workflow":
        return <ETLWorkflow ref={etlWorkflowRef} workflowId={workflowId} />;
      case "New File":
        return <NewFileTab />;
      default:
        return <ETLWorkflow ref={etlWorkflowRef} workflowId={workflowId} />;
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <NavigationBar 
        selectedTab={selectedTab} 
        onTabChange={handleTabChange} 
        mainMenu={mainMenu} 
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        handleLogout={handleLogout}
      />
      <ExitConfirmationModal
         open={openExitModal}
        onClose={handleCloseExitModal} 
        onConfirm={() => handleCloseExitModal('no')} 
        onSave={() => handleCloseExitModal('save')}
      />
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        {renderContent()}
      </Box>
    </Box>
  );
};

export default ParentComponent;